// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "-legacy." + {"56":"e3bcdb11","176":"0d6a0f30","466":"6cad59d3"}[chunkId] + ".js";
};